import {
  Dialog,
  DialogPanel,
  DialogTitle,
  Transition,
  TransitionChild
} from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import { Fragment } from 'react'

const SlideoverWithTitleAndActions = ({
  open,
  setOpen,
  title,
  description,
  actions,
  children,
  widthClassName
}) => {
  return (
    <Transition show={open} as={Fragment}>
      <Dialog as='div' className='relative z-10' onClose={setOpen}>
        <div className='fixed inset-0' />

        <div className='fixed inset-0 overflow-hidden'>
          <div className='absolute inset-0 overflow-hidden'>
            <div className='pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10 sm:pl-16'>
              <TransitionChild
                as={Fragment}
                enter='transform transition ease-in-out duration-500 sm:duration-700'
                enterFrom='translate-x-full'
                enterTo='translate-x-0'
                leave='transform transition ease-in-out duration-500 sm:duration-700'
                leaveFrom='translate-x-0'
                leaveTo='translate-x-full'
              >
                <DialogPanel
                  className={`pointer-events-auto w-screen ${widthClassName}`}
                >
                  <div className='flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl'>
                    <div className='h-0 flex-1 overflow-y-auto'>
                      <div className='bg-blue-700 px-4 py-6 sm:px-6'>
                        <div className='flex items-center justify-between'>
                          <DialogTitle className='text-base font-semibold leading-6 text-white'>
                            {title}
                          </DialogTitle>
                          <div className='ml-3 flex h-7 items-center'>
                            <button
                              type='button'
                              className='relative rounded-md bg-blue-700 text-blue-200 hover:text-white focus:outline-none'
                              onClick={() => setOpen(false)}
                            >
                              <span className='absolute -inset-2.5' />
                              <span className='sr-only'>Close panel</span>
                              <XMarkIcon
                                className='h-6 w-6'
                                aria-hidden='true'
                              />
                            </button>
                          </div>
                        </div>
                        <div className='mt-1'>
                          <p className='text-sm text-blue-300'>{description}</p>
                        </div>
                      </div>
                      {children}
                    </div>
                    {actions}
                  </div>
                </DialogPanel>
              </TransitionChild>
            </div>
          </div>
        </div>
      </Dialog>
    </Transition>
  )
}

SlideoverWithTitleAndActions.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  actions: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  // Breite des Panels. Eine lange Spaltenliste braucht mehr als die Vorgabe.
  widthClassName: PropTypes.string
}

SlideoverWithTitleAndActions.defaultProps = { widthClassName: 'max-w-lg' }

export default SlideoverWithTitleAndActions
